import * as firestoreService    from  '../../../../../common/firestore.service';
import { getUser } from '../../../../login/login.service';
import { Balance } from './transaction.model';

export async function getBalance(year: number, month: number, customerId: string, next: any) {
    const userEmail = getUser().email;
    
    console.log(`${month}-${year}-${customerId}`);
    var data={
        openingBalance:0,
        closeingBalance:0,
        id:''
    };
    const b1v = (pa:any) => {
        data['openingBalance']=pa.openingBalance
        data['id']=pa.id
    }
    const b2v = (pa:any) => {
        data['closeingBalance']=pa.closeingBalance
        next(data)
    }
    if (month===12){
        firestoreService.fetchSubDocument('Users', userEmail, 'Balances', `${3}-${year-1}-${customerId}`, Balance, b1v);  
        firestoreService.fetchSubDocument('Users', userEmail, 'Balances', `${2}-${year}-${customerId}`, Balance, b2v);  
    }
    else{
        firestoreService.fetchSubDocument('Users', userEmail, 'Balances', `${month}-${month<3?year:year-1}-${customerId}`, Balance, next);
    }
}